import { SortItem } from '@/components/OverviewTable/types';

export type JobOccurrenceTableColumn =
  | 'jobConfigurationName'
  | 'targetSystem.name'
  | 'frequency'
  | 'period'
  | 'plannedPeriod'
  | 'assigned'
  | 'review'
  | 'completedByUser.name'
  | 'state'
  | 'progress'
  | 'approvedBy'
  | 'contextMenu';

export function mapTableToDtoKeys<T extends string>(sortBy?: SortItem<T>[]) {
  return sortBy?.map((sortItem) => {
    switch (sortItem.key) {
      case 'period':
      case 'plannedPeriod':
        return { ...sortItem, key: 'end' };
      case 'approvedBy':
        return { ...sortItem, key: 'lastModificationTime' };
      case 'completedByUser.name':
        return { ...sortItem, key: 'executionCompleted' };
      default:
        return sortItem;
    }
  });
}
